import styled from 'styled-components'

export const CorpoModal = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 30px 40px;
  max-width: 450px;
`

export const ContainerDosBotoes = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  gap: 15px;
  margin-top: 20px;
`
